/**
 * 时间日期相关操作
 */

export const formatDBToAutoDateTime = (dateStr, sp) => {
  sp = sp || '-';
  if (dateStr) {
    const y = dateStr.substring(0, 4);
    const m = dateStr.substring(4, 6);
    const d = dateStr.substring(6, 8);
    const h = dateStr.substring(8, 10);
    const min = dateStr.substring(10, 12);
    const s = dateStr.substring(12);
    return `${y}${sp}${m}${sp}${d} ${h}:${min}:${s}`;
  } 
  return undefined;
}

/**
 * 日期格式化
 *  - 20010911 》 2001-09-11
 * @param {*} dateStr 
 */
export const formatDBToAuto = (dateStr, sp) => {
  sp = sp || '-';
  if (dateStr) {
    const y = dateStr.substring(0, 4);
    const m = dateStr.substring(4, 6);
    const d = dateStr.substring(6);
    return `${y}${sp}${m}${sp}${d}`;
  }
  return undefined;
}

/**
 * 时间格式化
 * 将 2018-09-23T11:54:16.000+0000 格式化成 2018/09/23 11:54:16
 * @param datetime 国际化日期格式
 * 
 */
export function format (datetime, s1, s2, s3) {
  return formatWithSeperator(datetime, s1 || "/", s2 || ":", s3);
}

/**
 * 时间格式化
 * 将 2018-09-23T11:54:16.000+0000 格式化成类似 2018/09/23 11:54:16
 * 可以指定日期和时间分隔符
 * @param datetime 国际化日期格式
 * @param nodeType 不传，默认datetime时分秒 ； end-23:59:59
 */
export function formatWithSeperator (datetime, dateSeprator = '-', timeSeprator = ':', nodeType) {
  if (datetime != null) {
    const dateMat = new Date(datetime);
    const year = dateMat.getFullYear();
    const month = dateMat.getMonth() + 1;
    const day = dateMat.getDate();
    const hh = nodeType === 'end' ? '23' : dateMat.getHours();
    const mm = nodeType === 'end' ? '59' : dateMat.getMinutes();
    const ss = nodeType === 'end' ? '59' : dateMat.getSeconds();
    return `${year}${dateSeprator}${month > 9 ? month : '0' + month}${dateSeprator}${day > 9 ? day : '0' + day} ${hh > 9 ? hh : '0' + hh}${timeSeprator}${mm > 9 ? mm : '0' + mm}${timeSeprator}${ss > 9 ? ss : '0' + ss}`;
  }
}



// WEBPACK FOOTER //
// ./src/utils/datetime.js